import {
  type Icon,
  IconBuildingStore,
  IconCalendar,
  IconChartPie,
  IconReceipt2,
  IconScale,
} from "@tabler/icons-react";

export type AddOn = {
  icon: Icon;
  title: string;
  description: string;
  price: string;
};

export const addOns: AddOn[] = [
  {
    icon: IconReceipt2,
    title: "Comandas",
    description: "Abra comandas e acompanhe o mapa de mesas. Feito pra bares e restaurantes.",
    price: "R$99",
  },
  {
    icon: IconBuildingStore,
    title: "Multi-estabelecimento",
    description: "Mais de uma loja no mesmo app, cada uma com seus próprios dados e estoque.",
    price: "R$99",
  },
  {
    icon: IconScale,
    title: "Integração com balança",
    description: "Pese e precifique produtos na hora da venda (balanças compatíveis).",
    price: "R$59",
  },
  {
    icon: IconChartPie,
    title: "Relatórios em gráficos",
    description: "Veja o que vende mais, quem compra mais e quem está devendo.",
    price: "R$49",
  },
  {
    icon: IconCalendar,
    title: "Agenda",
    description: "Compromissos, entregas e lembretes direto no sistema.",
    price: "R$19",
  },
];
